module.exports = __webpack_public_path__ + "img/count4.44ae6332.svg";